import { useEffect, useState } from "react";
import AgentPreferencesAPI from "../api/AgentPreferencesAPI";

const useSubmitAgentPreferences = () => {
	const [submission, setSubmission] = useState(null);
	const [loading, setLoading] = useState(true);
	const [submitting, setSubmitting] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		let cancelled = false;

		(async () => {
			setLoading(true);
			setError(null);

			try {
				const result = await AgentPreferencesAPI.getMySubmission();
				if (!cancelled) setSubmission(result?.submission || null);
			} catch (err) {
				if (!cancelled) setError(err.message);
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();

		return () => {
			cancelled = true;
		};
	}, []);

	const submit = async (answers, remarks) => {
		setSubmitting(true);

		try {
			const result = await AgentPreferencesAPI.submitPreferences(answers, remarks);
			return { success: true, data: result };
		} catch (err) {
			return { success: false, error: err.message };
		} finally {
			setSubmitting(false);
		}
	};

	return { submission, loading, submitting, error, submit };
};

export default useSubmitAgentPreferences;
